import React, { useState } from 'react'
import BackUpModal from './BackUpModal';
export default function BackUp({ className }) {
  const [openModal, setOpenModal] = useState({
    fullBackup: false,
    partialBackUp: false
  })


  const openReqModal = (e) => {
    if (openModal.fullBackup || openModal.partialBackUp) {
      return;
    }
    const { id } = e.target;

    if (id === 'full') {
      setOpenModal(prev => ({ ...prev, fullBackup: true }))
      return;
    }
    if (id === 'partial') {
      setOpenModal(prev => ({ ...prev, partialBackUp: true }))
      return;
    }

  }

  return (
    <>
      <ul className={className}>
        <li id='full' onClick={openReqModal}>Full Backup</li>
        <li id='partial' onClick={openReqModal}>Partial</li>
      </ul>
      <BackUpModal openModal={openModal} setOpenModal={setOpenModal} />
    </>

  )
}
